<template>
  <div class="w-1200 flex-center">
    <div class="back-title">{{ params.title }}</div>
    <div class="back-banner">
      <img :src="params.banner" alt="">
    </div>
    <div class="subtitle" v-if="params.video">活动视频</div>
    <div class="ifream-box" v-if="params.video">
      <iframe class="ifream-radio" width="100%" height="498" :src="params.video"></iframe>
    </div>
    <div class="subtitle" style="margin-bottom: 24px;">活动现场</div>
    <event-review
      :data="listData"
      @goPage="goHref"
    >
    </event-review>
    <div class="subtitle" style="margin-bottom: 24px;">其他活动</div>
    <event-review
      :data="otherActivty"
      @goPage="goBack"
    >
    </event-review>
  </div>
</template>

<script>
  import api from '../../model/api'
  import eventReview from './event-review';

  export default {
    name: "activty-back",
    components: {eventReview},
    data() {
      return {
        params: {},
        listData: [],
        otherActivty: [], // 其他回顾活动
        page: 1,
        lines: 16
      }
    },
    methods: {
      getListData() { // 获取数据
        let vars = {};
        vars.module = 'bsmMemberMng';
        vars.key = 'actreview';
        vars.conds = [
          `id=${this.$route.query.id}`
        ];
        api.sQuery(vars, this, data => {
          // console.log(data, '活动详情')
          if (data.data && data.data.length > 0) {
            this.params = data.data[0];
            this.params.banner = JSON.parse(data.data[0].banner)[0].$path + '&preview=true';
            this.listData = data.data[0].sites; // 活动现场
            if (this.listData && this.listData.length > 0) {
              this.listData.map(item => {
                item.imgUrl = JSON.parse(item.banner)[0].$path
              })
            }
          }
        })
      },
      getActivtyData() {  // 获取其他回顾活动
        let vars = {};
        vars.module = 'bsmMaActvtyQuery';
        vars.key = 'actreview';
        vars.paging = [];
        vars.conds = [];
        vars.dims = [];
        api.sQuery(vars, this, data => {
          // console.log(data, '其他回顾活动')
          if (data.data && data.data.length > 0) {
            this.otherActivty = data.data;
            this.otherActivty.map(item => {
              item.imgUrl = JSON.parse(item.banner)[0].$path;
            })
          }
        });
      },
      goHref(e) {
        let {url} = e;
        if (url) {
          window.open(url)
        }
      },
      goBack(e) {
        this.$router.push({
          name: 'back',
          query: {id: e.id}
        })
      },
      listerFuc () {
        let that = this;
        window.addEventListener("popstate", function(e) {
          // alert("我监听到了浏览器的返回按钮事件啦");//根据自己的需求实现自己的功能
          that.$router.push({
            name: 'theme',
            params: {
              isback: true
            }
          });
        }, false);
      },
      pushHistory () {
        let state = {
          title: "title",
          url: "#"
        };
        window.history.pushState(state, "title", "#");
        this.listerFuc();
      }
    },
    mounted() {
      this.getListData();
      this.getActivtyData();
      this.pushHistory();
    },
    destroyed () {
      window.removeEventListener('popstate',function () {})
    }
  }
</script>

<style scoped>
  .flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .back-title {
    line-height: 1.3;
    max-height: 62px;
    font-size: 24px;
    color: #000000;
    text-align: center;
    margin-top: 24px;
  }

  .back-banner {
    height: 439px;
    width: 100%;
    background-color: rosybrown;
    margin-top: 24px;
  }
  .back-banner img{
    height: 439px;
    width: 100%;
  }

  .subtitle {
    color: rgba(182, 11, 13, 1);
    position: relative;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 2px;
    margin-top: 24px;
  }

  .subtitle::before {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -140px;
    width: 100px;
    height: 2px;
    background-color: rgba(182, 11, 13, 1);
  }

  .subtitle::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 140px;
    width: 100px;
    height: 2px;
    background-color: rgba(182, 11, 13, 1);
  }

  .ifream-box {
    width: 90%;
    margin-top: 24px;
  }

  .ifream-radio {
    margin: 0;
    padding: 0;
    list-style-type: none;
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/activty/activty-back.vue